module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/rest-resource/~/axios/index.js
// module id = 1NHi
// module chunks = 0